var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.586 -83.919) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.919 -1.414)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.333,77.888V101.52c0,2.5,10.324,2.576,11.5,2.576s11.5-.072,11.5-2.576V77.888q-2.879,1.729-11.5,1.737T85.333,77.888Z",
    transform: "translate(-85.333 -72.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.834,6.346c7.094,0,11.5-1.217,11.5-3.173a.822.822,0,0,0-.072-.333C107.607.382,99.91.049,97.474.006,97.261,0,97.052,0,96.834,0s-.427,0-.641.006C93.756.049,86.06.381,85.4,2.84a.846.846,0,0,0-.07.333C85.334,5.129,89.74,6.346,96.834,6.346Z",
    transform: "translate(-85.334 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRod);
export default __webpack_public_path__ + "static/media/rod.fb5b52464f318d20e343640a63286106.svg";
export { ForwardRef as ReactComponent };